import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import AirArabiaTicketDetail from "./TicketDetail.airarabia.jsx";
import {
  getCompanyById,
  getMyCompany,
} from "../../../redux2/user/userSlice.js";
import { SUPER_ROLE } from "../../../common/constants.js";
import Loading from "../../Loading/index.jsx";
import logo from "../../../images/logo.png";
import airarabiaLogo from "../../../images/flight-logo/airarabia.png";
import "../style.css";

export const AirArabiaTicketInfo = React.forwardRef(
  ({ ticketData, companyInfo, passengerInfo }, ref) => {
    const dispatch = useDispatch();

    const { company, isLoading } = useSelector((state) => state.user);
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
      if (user?.role === SUPER_ROLE) {
        dispatch(getCompanyById(companyInfo));
      } else {
        dispatch(getMyCompany());
      }
    }, [dispatch, user?.role, companyInfo]);

    const { flight, travelers, passengers, specialRequests } = ticketData;
    const passengerList = travelers || passengers;

    const getSegment = (ref) => {
      return flight?.find((flight) => flight?.rph?.split("$")?.[4] === ref);
    };

    const getPassenger = (ref) => {
      if (travelers) {
        return travelers?.find(
          (passenger) => passenger?.travelRefNumber === ref
        );
      } else {
        return passengers?.find(
          (passenger) => passenger?.travelerRefNumber === ref
        );
      }
    };

    if (isLoading) return <Loading />;

    return (
      <div className="mx-10 my-4 text-black ticket-print" ref={ref}>
        <div className="my-1 text-lg font-semibold flight-header">
          <h1>Trip to {flight?.[0]?.arrivalAirport?.locationCode}</h1>
        </div>
        <hr />
        <div className="passenger-header">
          <div className="">
            <p>PREPARED FOR </p>
            <div className="flex flex-col">
              {passengerList?.map((passenger, index) => (
                <h1
                  className="text-xl font-normal tracking-wide text-gray-600"
                  key={index}
                >
                  {(passenger?.title || passenger?.name?.title) &&
                    `${passenger?.title || passenger?.name?.title}. `}
                  <span className="font-semibold uppercase">
                    {passenger?.name?.givenName
                      ? passenger?.name?.givenName +
                        " " +
                        passenger?.name?.surname
                      : passenger?.firstName + " " + passenger?.lastName}
                  </span>
                </h1>
              ))}
            </div>
            <div className="flex flex-row gap-5 justify-between font-light tracking-wide text-gray-500 text-md">
              <p className="">
                Confirmation number{": "}
                <span className="font-bold">
                  {ticketData?.confirmationCode || ticketData?.pnr}
                </span>
              </p>
            </div>
          </div>
          <div className="text-sm">
            <p>Passport Number</p>
            <div className="flex flex-col">
              {passengerInfo?.map((passenger, index) => (
                <h1
                  className="text-lg font-normal tracking-wide text-gray-600"
                  key={index}
                >
                  {passenger?.passportNumber}
                </h1>
              ))}
            </div>
          </div>
          <div className="flex justify-center items-center">
            <img
              src={airarabiaLogo}
              alt="logo"
              className="object-cover w-32 h-20"
            />
          </div>
        </div>
        <div className="line"></div>

        {flight?.map((segment, index) => {
          return (
            <AirArabiaTicketDetail
              data={segment}
              passengerList={passengerList}
              specialRequests={specialRequests}
              key={index}
              index={index}
            />
          );
        })}

        <div className="line"></div>

        <div className="p-2 my-2 border-1 border-slate-400">
          <h1 className="py-2 font-semibold text-md text-grey-700">
            Baggage Information
          </h1>
          <div className="row">
            <p className="col-3 sm:px-10">Passenger</p>
            <p className="col-3 sm:px-10">Flight</p>
            {/* <p className="col-4 sm:px-10">Type</p> */}
            <p className="col-4">Baggage Allowance</p>
          </div>
          {specialRequests?.[0]?.baggageRequests?.map((baggage, index) => {
            return (
              <FlightDetail
                baggage={baggage}
                getSegment={getSegment}
                getPassenger={getPassenger}
                key={index}
              />
            );
          })}
        </div>

        <div className="flex justify-between px-1 text-xs">
          {company ? (
            <>
              {/* <h1 className="text-xl font-bold">Booking Technologies PLC</h1> */}
              <h1 className="text-xl font-bold">{company?.name}</h1>
              <div className="text-xs">
                <div className="space-y-1">
                  <h3>Head Office: {company?.address} </h3>
                  <h3 className="text-center sm:ml-3">
                    {/* Addis Ababa, Ethiopia */}
                    Ethiopia
                  </h3>
                </div>
              </div>
              <div>
                <h2>Agency Office Phone:</h2>
                <h3>{company?.officeNumber}</h3>
                <h3>{company?.officeNumber2}</h3>
              </div>
            </>
          ) : (
            <>
              <img
                src={logo}
                alt=""
                style={{ width: "150px", height: "38px" }}
              />
              <div className="text-xs">
                <div className="space-y-1">
                  <h3>Head Office: Near the National Theater </h3>
                  <h3 className="text-center sm:ml-14">
                    Addis Ababa, Ethiopia
                  </h3>
                </div>
              </div>
              <div>
                <h2>Agency Office Phone:</h2>
                <h3>+251 115 511333 </h3>
                <h3>+251 115 514666</h3>
              </div>
              <div>
                <h2>Agency Mobile Phone:</h2>
                <h3>+251 922 238193</h3>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
);

function FlightDetail({ baggage, getSegment, getPassenger }) {
  const segment = getSegment(baggage?.flightRefNumberRPHList?.split("$")?.[4]);

  const passenger = getPassenger(baggage?.travelerRefNumberRPHList);

  // const baggageAllowance = getBaggageAllowance(baggage?.refs[0]);

  return (
    <div className="row sm:mx-2">
      <h1 className="col-3">
        {(passenger?.title || passenger?.name?.title) &&
          `${passenger?.title || passenger?.name?.title}. `}
        {passenger?.name?.givenName
          ? passenger?.name?.givenName + " " + passenger?.name?.surname
          : passenger?.firstName + " " + passenger?.lastName}
      </h1>
      <h1 className="col-3">
        {segment?.departureAirport?.locationCode} -{" "}
        {segment?.arrivalAirport?.locationCode}
      </h1>
      <h1 className="col-4">{baggage?.baggageCode}</h1>
      {/* <div className="col-4">
        {baggageAllowance?.PieceAllowance ? (
          <h1>
            <span className="font-semibold text-grey-700">
              {baggageAllowance?.PieceAllowance?.[0]?.TotalQuantity}{" "}
            </span>
            Piece(s){" "}
            {baggageAllowance?.WeightAllowance?.MaximumWeight[0]?.Value}{" "}
            {baggageAllowance?.WeightAllowance?.MaximumWeight[0]?.UOM} Plan
          </h1>
        ) : (
          <h1>
            <span className="font-semibold text-grey-700">
              {baggageAllowance?.WeightAllowance?.MaximumWeight[0]?.Value}{" "}
            </span>
            {baggageAllowance?.WeightAllowance?.MaximumWeight[0]?.UOM} Plan
          </h1>
        )}
      </div> */}
    </div>
  );
}
